import { FC } from 'react';
import { useAppSelector } from '../../../app/hooks';

import { GenericList } from '../../../shared/components/GenericList/GenericList';
import { ModeEnum, StatusEnum } from '../../../shared/models/Enums';
import { ResourcesService } from '../../../shared/services/ResourcesService';
import { selectUserLanguage } from '../../login/loginSlice';
import { changeMode, getCompanyAsync } from '../companySlice';
import { EditCompanyData } from '../models/EditCompanyData';

type CompaniesListProps = {
    companies: EditCompanyData[],
    companyStatus: StatusEnum,
    dispatch: Function
    loadCompanyEdit: Function,
    query: string
    setQuery: Function,
    onNext: Function,
    onPrevious: Function,
};

export const CompaniesList: FC<CompaniesListProps> = ({
    companies, companyStatus, dispatch, loadCompanyEdit, query, setQuery, onNext, onPrevious
}) => {
    const lang = useAppSelector(selectUserLanguage);
    const tableHeaders = ['#', ResourcesService.translate('Title', lang), ResourcesService.translate('Surveys count', lang)];

    return (
        <GenericList
            lang={lang}
            h2={ResourcesService.translate('Companies', lang)}
            headContent={
                <tr>
                    {
                        tableHeaders.map(h => <th key={h}>{h}</th>)
                    }
                </tr>
            }
            bodyContent={
                companies.map((s, i) =>
                    <tr key={i} onClick={() => dispatch(getCompanyAsync(s.id))}>
                        <td>{s.id.substring(0, 8)}...</td>
                        <td>{ResourcesService.translateInput(s.titleBg, s.titleEn, s.titleThird, lang)}</td>
                        <td>{s.surveysCount}</td>
                    </tr>
                )
            }
            listStatus={companyStatus}
            numberOfRows={5}
            numberOfColumns={tableHeaders.length}
            onCreateClick={() => dispatch(changeMode(ModeEnum.Create))}
            searchValue={query}
            onSearch={(value: string) => dispatch(setQuery(value))}
            onNext={() => dispatch(onNext())}
            onPrevious={() => dispatch(onPrevious())}
        />
    );
}